import type { ReactNode } from 'react';

export const relatedLinks: {
  icon: ReactNode;
  title: string;
  link: string;
}[] = [];
